// §4.4 partial — admin/users routes.
// Covers: /admin/users, /admin/users/:id (nested with profile tabs),
//         /admin/users/:id/test-mode, /admin/online (live sessions desk).
import { createElement } from "react";
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const UsersListPage = lazyWithRetry(() => import("./pages/UsersListPage"));
const UserProfileLayout = lazyWithRetry(
  () => import("./pages/UserProfileLayout"),
);
const UserTestModePage = lazyWithRetry(
  () => import("./pages/UserTestModePage"),
);
// Operator 2026-06-11: live sessions desk in the sidebar between Usuarios and
// Trades. Backed by GET /api/v2/admin/online-sessions (admin route A46).
const OnlineSessionsPage = lazyWithRetry(
  () => import("./pages/OnlineSessionsPage"),
);

// Tab pages — lazy so a sibling agent's missing file won't break the build.
const OverviewTab = lazyWithRetry(() => import("./pages/tabs/OverviewTab"));
const PurchasesTab = lazyWithRetry(() => import("./pages/tabs/PurchasesTab"));
const TokensTab = lazyWithRetry(() => import("./pages/tabs/TokensTab"));
const TradesTab = lazyWithRetry(() => import("./pages/tabs/TradesTab"));
const ActivityTab = lazyWithRetry(() => import("./pages/tabs/ActivityTab"));

// Index redirect: /admin/users/:id → /admin/users/:id/overview
// Use createElement to avoid JSX in a .ts file (JSX requires .tsx).
const overviewRedirect = createElement(Navigate, {
  to: "overview",
  replace: true,
});
const activityRedirect = createElement(Navigate, {
  to: "../activity",
  replace: true,
});

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [
      { path: "/admin/users", Component: UsersListPage },
      { path: "/admin/online", Component: OnlineSessionsPage },
      {
        path: "/admin/users/:id",
        Component: UserProfileLayout,
        children: [
          { index: true, element: overviewRedirect },
          { path: "overview", Component: OverviewTab },
          { path: "purchases", Component: PurchasesTab },
          { path: "tokens", Component: TokensTab },
          { path: "trades", Component: TradesTab },
          { path: "activity", Component: ActivityTab },
          { path: "audit", element: activityRedirect },
        ],
      },
      { path: "/admin/users/:id/test-mode", Component: UserTestModePage },
    ],
  },
];

export default routes;
